import { Provider } from "react-redux";
import store from "./../Redux/store";
import BlogContainer from "./BlogContainer";
import Container from "./Container";
import Header from "./Header";
import Layout from "./Layout";
import Navbar from "./Navbar";
import SearchBar from "./SearchBar";
import SelectedFilters from "./SelectedFilters";

const App = () => {
  return (
    <Provider store={store}>
      <Layout>
        <Navbar />
        <Container>
          <SearchBar />
          <Header />
          <SelectedFilters />
          <BlogContainer />
        </Container>
      </Layout>
    </Provider>
  );
};

export default App;
